import React, {
	Component
} from 'react';
import styled from 'styled-components';


const ButtonMoverBody = styled.div`
	user-select: none;
	-webkit-appearance: none;
	box-shadow: none !important;
	position: relative;
	& * {
		pointer-events: none;
	}
`

export class ButtonMover extends Component {
	state = {
		pointerCount: 0
	}

	up = () => {
		this.setState({pointerCount: this.state.pointerCount + 1});
	}

	down = () => {
		if(this.state.pointerCount){
			this.setState({pointerCount: this.state.pointerCount - 1});
		}
	}

	componentWillUnmount(){
		// this.ref.style.display = 'none';
	}

	render(){
		// console.log(this.state.pointerCount);
		var {style, block, ...rest} = this.props;
		style = style || {};
		return (
			<ButtonMoverBody
				{...rest}
				onPointerDown={this.up}
				onPointerUp={this.down}
				onPointerOut={this.down}
				style={{top: this.state.pointerCount ? 4 : 0}}
				// ref={(ref) => {
				// 	this.ref = ref;
				// }}
			>
				{this.props.children}
			</ButtonMoverBody>
		)
	}
}

// const BgButtonBody = styled.div`
// 	display: inline-block;
// 	background-size: cover;
// 	color: white;
// 	font-size: 8vw;
// 	line-height: 2em;
// 	text-shadow: 0.4vw 0.4vw 0.1vw #24377b, -0.4vw -0.4vw 0.1vw #24377b, 0.4vw -0.4vw 0.1vw #24377b, -0.4vw 0.4vw 0.1vw #24377b;
// 	text-decoration: none;
// `

// export class BgButton {
// 	render(){
// 		return (
// 			<BgButtonBody style={{backgroundImage: `url(${this.props.src})`}}>
// 				{this.props.to ? (
// 					<Link>

// 					</Link>
// 				) : null }
// 			</BgButtonBody>
// 		)
// 	}
// }
